exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data[data-v-4822fea7]{margin-bottom:18px;display:-ms-grid;display:grid;grid-gap:15px}@media only screen and (min-width:500px){.data[data-v-4822fea7]{margin-bottom:30px;-ms-grid-columns:137px 1fr;grid-template-columns:137px 1fr}}.data__image[data-v-4822fea7]{width:100%;height:auto}.data__info[data-v-4822fea7]{display:-ms-grid;display:grid;-ms-grid-rows:(auto)[3];grid-template-rows:repeat(3,auto);grid-gap:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4822fea7","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/data/Data.vue
// module id = f0bdff4ce973131a00b0
// module chunks = 9